import axios from 'axios';
import {atomicwarHost} from './hosts';

const instance = axios.create(
    {
        baseURL:atomicwarHost,
        timeout:10000
    }
);

instance.interceptors.request.use(config=>{
    console.log(config)
    if (localStorage.token1) {   
        config.headers.Authorization = 'Bearer ' + localStorage.token
    } 
    return config
})


instance.interceptors.response.use( (res)=>{
    console.log(res);
    return res;
},error => { 
        return Promise.reject(error)
     } 
 )
 
export default instance;
